// 注册全局组件 vite方式
import { defineAsyncComponent } from "vue";
/**
 * @description 在src/components目录下创建文件，即 src/components/xxx.vue
 * @description 在src/components目录下创建目录及文件，即 src/components/xxx文件夹/xxx.vue
 */
const components = import.meta.glob("../components/*/index.vue");
const pattern = /\/([^/]+)(?=\/)/g;
export default function install(app) {
  for (const [key, value] of Object.entries(components)) {

    let name = ''
    // 使用正则表达式匹配并提取指定字符串之间的内容
    let match = null;
    while ((match = pattern.exec(key)) !== null) {
      const content = match[1];
      if (content !== 'components') { 
      
        name = content
      }
    }
    app.component(name, defineAsyncComponent(value));
  }
}
 